export default {"src":"/_next/static/media/instagram.e10426fe.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};